export default {
      id: "ic_read_announcements-usage",
      viewBox: "0 0 14 14",
      url: "/" + "images/icons.3.109.2.svg#ic_read_announcements-usage",
      toString: function () {
        return this.url;
      }
    }